import React, { useState, useEffect } from "react";
import { Statistic, Row, Col, Button, Table } from "antd";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Legend,
} from "recharts";
import "./DetailView.css";
import {
  CHART_TITLES,
  supplierGoalstablecolumns,
  supplierGoalstabledata,
} from "../../constants/Constants";
import rollbackIcon from "../../assets/icons/rollback.png";
import supplierIcon from "../../assets/icons/suppliers.png";
import goalcountIcon from "../../assets/icons/goal_active.png";
import rankingIcon from"../../assets/icons/quality.png"
import targetachievedIcon from "../../assets/icons/target_achieved.png";
import goalsIcon from"../../assets/icons/goals_icon.png";
import ExcelTable from "./ExcelTable";

const getStatisticsIcon = (title) => {
  let icons = null;
  if (title === "Suppliers YOY change") {
    icons = goalsIcon;
  } else if (title === "Total Goals"||title==="Total No. of Suppliers") {
    icons = supplierIcon;
  } else if (title === "Active Goals") {
    icons = goalcountIcon;
  } else if (title === "Target Achieved percentage") {
    icons = targetachievedIcon;
  }else if(title==="Supplier Rank"){
    icons=rankingIcon;
  }

  return icons;
};

const renderCustomLegend = (title) => {
  return <div className="text-center text-xs font-semibold mt-2">{title}</div>;
};

const SupplierSubmittedGoalsDetailView = ({
  data,
  handleBackClick,
  kpiName,
  role,
}) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);


  const supplierStats = [
    { title: role=="System Admin"?"Total No. of Suppliers":"Total Goals", value: role=="System Admin"?data?.tySupplierCount:data?.tyTotalGoalCount?.toString() || "0" },
    { title: "Active Goals", value: data?.activeGoalCount?.toString() || "0" },
    { title: "Target Achieved percentage", value:role=="System Admin"?data?.targetAchievedPercentage?.toFixed(2):`${data?.goalAchievedPercentage?.toFixed(2) || "0"}%` },
    { title: "Suppliers YOY change", value: data?.goalsYoy || "0" },
    ...(role == "System Admin" ? [] : [{
      title: "Supplier Rank",
      value: (`${data.supplierRank}/${data.totalSuppliers}`)||0
    }])
  ];


  const transformSuppliersOverYearsData = () => {
    if (!data?.suppliersOverYears) return [];

    const groupedByPillar = {};
    data.suppliersOverYears.forEach(item => {
      const { pillar, yearValues } = item;
      if (!groupedByPillar[pillar]) {
        groupedByPillar[pillar] = { name: pillar };
      }
      groupedByPillar[pillar][yearValues.year] = yearValues.value;
    });

    return Object.values(groupedByPillar);
  };
  
  const suppliersYoyData = transformSuppliersOverYearsData();

 
  const getReductionData = (pillarName) => {
    const pillar = data?.itemsReduction?.find(item => item.pillar === pillarName);
    if (pillar && pillar.value) {
      return [
        { name: "Used", value: pillar.value.used, color: "#277A30" },
        { name: "Remaining", value: pillar.value.remaining, color: "#144FA8" },
      ];
    }
    return [
      { name: "Used", value: 0, color: "#277A30" },
      { name: "Remaining", value: 0, color: "#144FA8" },
    ];
  };

  return (
    <div className="md:p-0 p-2">
      <div className="detail-view-header flex justify-between items-center mb-4 md:flex-row flex-col-reverse">
        <div className="heading text-2xl font-medium text-[#004481]">
          Detail View: {kpiName}
        </div>
        <Button
          shape="round"
          icon={<img src={rollbackIcon || "/placeholder.svg"} alt={"back"} className="w-10 h-5" />}
          size="60px"
          className="top-[3px] w-[100px] h-[30px] bg-[#F8FAFC] self-end"
          style={{ border: "1px solid #A1BAD1" }}
          onClick={handleBackClick}
        >
          Back
        </Button>
      </div>

      <div className="outer-card p-4 rounded-2xl shadow-md bg-[#F8FAFC] mb-6">
        <Row gutter={[16, 16]}>
          {supplierStats.map((stat, index) => {
            return (
              <Col key={index} xs={24} sm={12} md={role == "System Admin" ? 8 : 7} lg={role == "System Admin" ? 6 : 8}>
                <div className="statistic-card p-4 rounded-2xl bg-white ml-2">
                  <img
                    src={stat && getStatisticsIcon(stat?.title)}
                    alt="icon"
                    className="md:w-18 md:h-18 w-16 h-16"
                  />
                  <Statistic
                    title={
                      <span className="statistic-title text-sm">
                        {stat?.title}
                      </span>
                    }
                    value={stat?.value}
                    valueStyle={{
                      color: "rgb(1 77 78)",
                      fontSize: isMobile ? "20px" : "20px",
                      fontWeight: 600,
                      textAlign: "center",
                      marginLeft: "15px",
                    }}
                  />
                </div>
              </Col>
            );
          })}
        </Row>
      </div>

      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mb-6">
        <Col xs={{ span: 24, order: 2 }} xl={{ span: 12, order: 1 }}>
          <div className="chart-card bg-white p-4 rounded-lg border-2 border-[#d1d5dc]">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <ResponsiveContainer width="100%" height={150}>
                  <PieChart>
                    <Pie
                      data={getReductionData("Energy")}
                      cx="50%"
                      cy="50%"
                      innerRadius={40}
                      outerRadius={60}
                      paddingAngle={0}
                      dataKey="value"
                    >
                      {getReductionData("Energy").map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.color} />
                      ))}
                    </Pie>
                    <Tooltip />
                  </PieChart>
                </ResponsiveContainer>
                {renderCustomLegend(CHART_TITLES.ENERGY_CONSUMPTION)}
              </div>

              <div>
                <ResponsiveContainer width="100%" height={150}>
                  <PieChart>
                    <Pie
                      data={getReductionData("Waste")}
                      cx="50%"
                      cy="50%"
                      innerRadius={40}
                      outerRadius={60}
                      paddingAngle={0}
                      dataKey="value"
                    >
                      {getReductionData("Waste").map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.color} />
                      ))}
                    </Pie>
                    <Tooltip />
                  </PieChart>
                </ResponsiveContainer>
                {renderCustomLegend(CHART_TITLES.WASTE_REDUCTION)}
              </div>

              <div>
                <ResponsiveContainer width="100%" height={150}>
                  <PieChart>
                    <Pie
                      data={getReductionData("Packaging")}
                      cx="50%"
                      cy="50%"
                      innerRadius={40}
                      outerRadius={60}
                      paddingAngle={0}
                      dataKey="value"
                    >
                      {getReductionData("Packaging").map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.color} />
                      ))}
                    </Pie>
                    <Tooltip />
                  </PieChart>
                </ResponsiveContainer>
                {renderCustomLegend(CHART_TITLES.PACKAGING_REDUCTION)}
              </div>
            </div>
            <div className="mt-4 flex justify-center">
              <div className="flex items-center">
                <div className="w-4 h-4 bg-[#277A30] mr-2"></div>
                <span className="text-xs mr-4">Used</span>
                <div className="w-4 h-4 bg-[#144FA8] mr-2"></div>
                <span className="text-xs">Remaining</span>
              </div>
            </div>
          </div>
        </Col>
       {role=="System Admin" &&  <Col xs={{ span: 24, order: 2 }} xl={{ span: 12, order: 1 }}>
          <div className="chart-card bg-white p-4 rounded-lg border-2 border-[#d1d5dc]">
            <div className="text-xs font-semibold mb-2">
              {CHART_TITLES.SUPPLIERS_OVER_YEARS}
            </div>
            <ResponsiveContainer width="100%" height={200}>
              <BarChart
                data={suppliersYoyData}
                margin={{
                  top: 5,
                  right: 30,
                  left: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="2024" fill="#82ca9d" />
                <Bar dataKey="2025" fill="#ffc658" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </Col>}
      </Row>

      {role=="System Admin" && <div className="flex justify-end mr-2 mt-2 mb-1">
        <ExcelTable tableData={data?.goalsTable} title="Supplier Submitted Goals" />
      </div>
      }
     {role=="System Admin" && <Row className="mt-2 p-[8px]">
        <Col span={24}>
          <div className="bg-white rounded-lg border-2 border-[#d1d5dc]">
            <Table
              columns={supplierGoalstablecolumns}
              dataSource={data?.goalsTable || supplierGoalstabledata}
              pagination={false}
              className="supplier-goals-table"
              rowClassName={(record, index) =>
                index % 2 === 0 ? "bg-[#F8FAFC]" : "bg-white"
              }
            />
          </div>
        </Col>
      </Row>}
    </div>
  );
};

export default SupplierSubmittedGoalsDetailView;
